export const LOGO_SRC = "/assets/igniva-logo.png";

// SÓ FOTOGRAFIAS OFICIAIS DAS MARCAS (ficheiros em /public/assets/brands).
// null = espaço reservado "Imagem oficial em breve" até haver fotografia oficial autorizada.
const IMG = {
  ltKitchen: "/assets/brands/lithotech/cocina-composicion.jpg",
  ltWorktop: "/assets/brands/lithotech/detalle-encimera.jpg",
  ltBlanc: "/assets/brands/lithotech/blanc-calacatta-gold.jpg",
  ltOda: "/assets/brands/lithotech/oda-ice-honed.jpg",
  ltFrame: "/assets/brands/lithotech/frame-soft-textured.jpg",
  fsGoldInterior: "/assets/brands/foster/pvd-gold-interior.jpg",
  fsGunMetal: "/assets/brands/foster/pvd-gun-metal-island.jpg",
  fsGoldSink: "/assets/brands/foster/pvd-gold-sink-detail.jpg",
  mcCharger: "/assets/brands/mastercharge/carregamento-bancada.png",
  mcEarbuds: "/assets/brands/mastercharge/auriculares-bancada.jpg",
  mcHeadphones: "/assets/brands/mastercharge/auscultadores-bancada.jpg",
};

// Cada marca é definida aqui e no bloco `brand.<slug>` dos ficheiros de textos (src/i18n).
// exclusive: só a Lithotech tem distribuição exclusiva em Portugal pela IGNIVA (confirmado).
export const BRANDS = [
  { slug: "lithotech", name: "Lithotech", category: "superficies", exclusive: true, apps: ["cozinhas", "banhos", "mobiliario", "revestimentos"],
    officialSite: "https://www.lithotechslabs.com/",
    docs: [{ label: "Catálogo Geral Lithotech (PDF)", url: "https://www.lithotechslabs.com/wp-content/uploads/2026/02/Cat-Lithotech-EdI-2026.pdf" }], video: null, logo: null,
    image: IMG.ltKitchen, gallery: [IMG.ltBlanc, IMG.ltWorktop] },
  { slug: "foster", name: "Foster", category: "equipamento", exclusive: false, apps: ["cozinhas"],
    officialSite: "https://www.fosterspa.com/",
    docs: [], video: null, logo: null,
    image: IMG.fsGoldInterior, gallery: [IMG.fsGoldSink, IMG.fsGunMetal] },
  { slug: "mastercharge", name: "Mastercharge", category: "tecnologia", exclusive: false, apps: ["cozinhas", "mobiliario", "integrada"],
    officialSite: "https://www.master-charge.co.uk/",
    docs: [{ label: "Mastercharge Invisible LR — Manual (PDF)", url: "https://www.master-charge.co.uk/wp-content/uploads/2025/04/MasterchargeLRUserM-04-2025.pdf" }], video: "Fr1QA8KWjF4", logo: null,
    image: IMG.mcCharger, gallery: [IMG.mcEarbuds, IMG.mcHeadphones] },
];

export const CATEGORIES = ["superficies", "equipamento", "tecnologia"];
export const APP_IDS = ["cozinhas", "banhos", "mobiliario", "revestimentos", "integrada"];

export const APPLICATIONS = [
  { id: "cozinhas", image: IMG.ltKitchen },
  { id: "banhos", image: IMG.ltBlanc },
  { id: "mobiliario", image: IMG.ltFrame },
  { id: "revestimentos", image: IMG.ltOda },
  { id: "integrada", image: IMG.mcCharger },
].map((a) => ({ ...a, brands: BRANDS.filter((b) => b.apps.includes(a.id)).map((b) => b.name).join(" · ") }));

export const EXPLORER_ITEMS = [
  { id: "lithotech-superficies", brand: "lithotech", applications: ["cozinhas", "banhos", "mobiliario"], aesthetics: ["pedra", "grande_formato"], image: IMG.ltKitchen },
  { id: "lithotech-revestimentos", brand: "lithotech", applications: ["revestimentos", "banhos"], aesthetics: ["pedra", "grande_formato"], image: IMG.ltBlanc },
  { id: "foster-lava-loucas", brand: "foster", applications: ["cozinhas"], aesthetics: ["aco"], image: IMG.fsGoldSink },
  { id: "foster-torneiras", brand: "foster", applications: ["cozinhas"], aesthetics: ["aco"], image: IMG.fsGunMetal },
  { id: "mastercharge-carregamento", brand: "mastercharge", applications: ["cozinhas", "mobiliario", "integrada"], aesthetics: ["integrado"], image: IMG.mcCharger },
];

// Imagem principal e imagem de "A IGNIVA": apenas fotografias oficiais da Lithotech.
export const HERO_IMAGES = [IMG.ltKitchen, IMG.ltWorktop, IMG.ltOda];
export const ABOUT_IMAGE = IMG.ltFrame;

export const PROJECT_TYPES = ["residencial", "hospitality", "comercial", "retalho", "outro"];
export const PARTNER_TYPES = ["arquiteto", "designer", "estudio_cozinhas", "marmorista", "fabricante", "promotor", "outro"];
